import { StandardEvents } from '@shopify/events';

const TOTAL_SELECTOR = '#MainContent .product-details .buy-buttons-block .add-to-cart-button[data-testid="standalone-add-to-cart"] [data-essentia-atc-cart-total]';
const BASE = window.Shopify?.routes?.root || '/';
const CART_URL = (BASE.endsWith('/') ? BASE : BASE + '/') + 'cart.js';
const numberFormat = new Intl.NumberFormat('es-PY', { maximumFractionDigits: 0 });
let revision = 0;
let lastCart = null;

function formatTotal(cart) {
  const minorUnits = Number(cart.total_price);
  if (!Number.isFinite(minorUnits)) return null;
  const currency = String(cart.currency || 'PYG').toUpperCase();
  if (currency === 'PYG') return 'Gs. ' + numberFormat.format(Math.round(minorUnits / 100));
  try {
    return new Intl.NumberFormat('es-PY', { style: 'currency', currency }).format(minorUnits / 100);
  } catch {
    return null;
  }
}

function updateVisibleButtons(cart) {
  const total = formatTotal(cart);
  const show = Boolean(total && Number(cart.item_count) > 0);
  for (const element of document.querySelectorAll(TOTAL_SELECTOR)) {
    const label = show ? 'Total sin envío: ' + total : '';
    if (element.textContent !== label) element.textContent = label;
    if (element.hidden !== !show) element.hidden = !show;
  }
}

async function refreshTotal() {
  const current = ++revision;
  try {
    const response = await fetch(CART_URL, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) return;
    const cart = await response.json();
    if (current !== revision) return;
    lastCart = cart;
    updateVisibleButtons(cart);
  } catch {
    return;
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
  try {
    if (event.promise) await event.promise;
  } catch {
    return;
  }
  refreshTotal();
});
document.addEventListener('theme-drawer:open', refreshTotal);
window.addEventListener('pageshow', refreshTotal);
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') refreshTotal();
});

function initialize() {
  const root = document.querySelector('#MainContent');
  if (!root) return;
  const observer = new MutationObserver(() => {
    if (lastCart) updateVisibleButtons(lastCart);
  });
  observer.observe(root, { childList: true, subtree: true });
  refreshTotal();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
} else {
  initialize();
}
